import React, { useState } from 'react';
import { twitter, linkedIn, facebook, instagram  } from "../../assets/images";
import * as PR from "../../prime-modules/index";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { globalConfig } from '../../constants';

const Footer = () => {
    const { affiliate } = useSelector(state => state.language?.activelang);
    const [year] = useState(new Date().getFullYear())
    const appName = process.env.REACT_APP_NAME;

    const socialLinks = {
        universal: {
          twitter: 'https://x.com',
          linkedIn: 'https://www.linkedin.com/company/bluehouse-technology',
          facebook: 'https://www.facebook.com',
          instagram: 'https://www.instagram.com',
        },
        data2go: {
          twitter: 'https://x.com/data2go_mobi',
          linkedIn: 'https://uk.linkedin.com/company/bluehouse-technology',
          facebook: 'https://www.facebook.com/data2go.mobi',
          instagram: 'https://www.instagram.com/data2go.mobi',
        }
    };

    const selectedLinks = appName === 'data2go' ? socialLinks.data2go : socialLinks.universal;
    
    return (
    <>
        <footer className="footer-section">
            {/* <div className='footer-info'>
                <div className='grid'>
                    <div className="col-12 md:col-6 lg:col-3 order-1">
                        <PR.Image src={footerLogo} alt="data2go logo"/>
                    </div>
                    <div className="col-12 md:col-6 lg:col-3 order-2">
                        <h3>{affiliate?.AFFNL0028}</h3>
                        <p><a href={`tel:${globalConfig.callUsPhoneNumber}`} className="email-link">{globalConfig.callUsPhoneNumber}</a></p> 
                        <p><a href={`mailto:${globalConfig.supportEmail}`} className="email-link">{globalConfig.supportEmail}</a></p>
                        <p><a href={`mailto:${globalConfig.salesEmail}`} className="email-link">{globalConfig.salesEmail}</a></p>
                    </div>
                    <div className="col-12 md:col-6 lg:col-3 order-3">
                        <h3>{affiliate?.AFFNL0029}</h3>
                        <p className='footer-button' onClick={navigate.bind(null,"/privacy-policy")}>{affiliate?.AFFNL0017}</p>
                        <p className='footer-button' onClick={navigate.bind(null,"/terms-and-conditions")}>{affiliate?.AFFNL0018}</p>
                        <p className='footer-button' onClick={navigate.bind(null,"/cookie-policy")}>{affiliate?.AFFNL0021}</p>
                    </div>
                    <div className="col-12 md:col-6 lg:col-3 order-4">
                        <h3>{affiliate?.AFFNL0030}</h3>
                        <div className='flex align-center gap-2 payment-accept'>
                            <PR.Image src={visa} alt="Visa"/>
                            <PR.Image src={masterCard} alt="Master Card"/>
                            <PR.Image src={applePay} alt="Apple Pay"/>
                            <PR.Image src={gPay} alt="Google Pay"/>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className='copyrights-section'>
                <div className='flex align-center justify-content-center mobile-flex'>
                    <div className='copyrights-left'>
                        {
                            appName === 'gopamwe' || appName === 'gopamwe-corporate'
                            ? <p>&copy;{affiliate.AFFNL0152 || "2025"} {affiliate.AFFNL0151 || "GO PAMWE"}. {affiliate.AFFNL0150 || "All Rights Reserved."}</p>
                            : <p>&copy;{year} {affiliate?.AFFNL0013} | {affiliate?.AFFNL0012} <Link to="https://www.bluehouse-technology.co.uk/" target='_blank'>Bluehouse Technology.</Link></p>
                        }
                    </div>
                    {/* <div className='social-icons flex align-center gap-4'>
                        <Link to={selectedLinks.twitter} target='_blank'><PR.Image src={twitter} alt="Twitter"/></Link>
                        <Link to={selectedLinks.linkedIn} target='_blank'><PR.Image src={linkedIn} alt="LinkedIn"/></Link>
                        <Link to={selectedLinks.facebook} target='_blank'><PR.Image src={facebook} alt="Facebook"/></Link>
                        <Link to={selectedLinks.instagram} target='_blank'><PR.Image src={instagram} alt="Instagram"/></Link>
                    </div> */}
                </div>
            </div>
        </footer>
    </>
  );
};

export default Footer; 